module.exports = "./src/client/static/xml/fattura_pa_asso_software.xsl?4ed5bc237a3cb9268a609381de56cb23";